import React from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import type { LatLng, Map } from "leaflet";
import "leaflet/dist/leaflet.css";

const OPEN_STREET_MAP_MAX_NATIVE_ZOOM = 19;
const MAX_ZOOM = 21;

export interface MiniMapProps {
  // 中心位置（緯度経度）
  center: LatLng;

  // コンテナのスタイル
  containerStyle?: React.CSSProperties;

  // 地図のズームレベル
  zoom?: number;

  // MapContainerへの参照
  mapRef?: React.RefObject<Map>;

  // 追加のコンポーネント（マーカーなど）
  children?: React.ReactNode;

  // ズーム機能を有効にするかどうか
  enableZoom?: boolean;
}

export const MiniMap: React.FC<MiniMapProps> = ({
  center,
  containerStyle = { width: "200px", height: "200px" },
  zoom = 15,
  mapRef,
  children,
  enableZoom = false,
}) => {
  return (
    <MapContainer
      ref={mapRef}
      zoomControl={enableZoom}
      center={center}
      style={containerStyle}
      zoom={zoom}
      minZoom={14}
      maxZoom={19}
      scrollWheelZoom={enableZoom}
      doubleClickZoom={enableZoom}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        maxNativeZoom={OPEN_STREET_MAP_MAX_NATIVE_ZOOM}
        maxZoom={MAX_ZOOM}
      />
      {children}
    </MapContainer>
  );
};

export default MiniMap;
